import { useQuery } from '@apollo/client';
import _ from 'lodash';

import { useUpdateSubscription } from 'src/state/actions/users';
import { filteredSubscriptions as filteredSubscriptionsQuery } from 'shared/graphql/subscription/queries';

export default function useSubscriptions() {
  const { data, ...apolloValues } = useQuery(filteredSubscriptionsQuery, {
    fetchPolicy: `network-only`,
  });
  const handleUnsubscribeDispensaryCustomer = useUpdateSubscription();

  const unsubscribeToDispensaries = async (customerIds) => {
    await Promise.all(
      _.map(customerIds, (customerId) =>
        handleUnsubscribeDispensaryCustomer(customerId, false, {
          refetchQueries: [{ query: filteredSubscriptionsQuery }],
        })
      )
    );
  };

  return { subscriptions: data?.filteredSubscriptions || [], ...apolloValues, unsubscribeToDispensaries };
}
